module.exports = __webpack_public_path__ + "img/mediclub-logo-oneline.091e492.svg";